import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f8f6c0e6&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f6c0e6')) {
      api.createRecord('f8f6c0e6', component.options)
    } else {
      api.reload('f8f6c0e6', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f8f6c0e6&", function () {
      api.rerender('f8f6c0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eWVoLuHXxw8v/JS/imageCarousel.vue"
export default component.exports